const inicialGroup = ['PT_FLEX2']
const inicialSuperiorGroup = ['PS_FLEX2']
const infinitaGroup = ['PS_CFFLEX2']
const infinitaBistroGroup = ['PI_GRFLEX2']

const colorClasses = (code) => {
  if (inicialGroup.includes(code)) {
    return '#dd0915'
  } else if (inicialSuperiorGroup.includes(code)) {
    return '#dd0915'
  } else if (infinitaGroup.includes(code)) {
    return '#000'
  } else if (infinitaBistroGroup.includes(code)) {
    return '#000'
  }
}

const arrowPositions = (code) => {
  if (inicialGroup.includes(code)) {
    return '41.5%'
  } else if (inicialSuperiorGroup.includes(code)) {
    return '58%'
  } else if (infinitaGroup.includes(code)) {
    return '91.5%'
  } else if (infinitaBistroGroup.includes(code)) {
    return '91.5%'
  }
}

export {inicialGroup, inicialSuperiorGroup, infinitaGroup, infinitaBistroGroup, arrowPositions, colorClasses}
